import {
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import mixpanel from "mixpanel-browser";
import { MouseEvent, useState } from "react";
import { sendEvent } from "../../Utils/firebaseLogger";
import useAuthState from "../../Utils/store";
import FormatNumberVisible from "../FormatData/FormatNumberVisible";
import "./ProfileMenu.scss";
function ProfileMenu() {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const { isLoggedIn, user, logout } = useAuthState();

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {isLoggedIn() && (
        <>
          <IconButton onClick={handleClick} sx={{ p: 0 }}>
            <Stack
              sx={{
                width: "32px",
                height: "32px",
                padding: "7px 8px 9px 8px",
                borderRadius: "60px",
                border: " 1px solid #E2E8F0",
              }}
            >
              <img src={"/icons/avatar-icon.png"} alt="avatar" />
            </Stack>
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            sx={{
              "& .MuiMenu-list": {
                width: "170px",
                borderRadius: "8px",
                border: "1px solid  #F1F5F9",
                boxShadow: "0px 4px 17px 0px #F1F1F4",
              },
            }}
            PaperProps={{
              sx: {
                marginTop: "20px",
                position: "fixed", // added position fixed
              },
            }}
          >
            <MenuItem
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
              }}
            >
              <Typography fontSize={"14px"} fontWeight={600} noWrap>
                {user?.firstName} {user?.lastName}
              </Typography>
              <Typography fontSize={"13px"} fontWeight={400} noWrap>
                {FormatNumberVisible(user?.phoneNumber)}
              </Typography>
            </MenuItem>
            <Divider sx={{ borderColor: "#F1F5F9", borderWidth: 1, mx: 2 }} />
            <MenuItem
              onClick={() => {
                logout();
                sendEvent(`click_logout_button`, {});
                mixpanel.reset();
              }}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                minHeight: "40px",
              }}
            >
              <Typography fontSize={"14px"} fontWeight={400} noWrap>
                Çıkış Yap
              </Typography>
              <img
                src={"/icons/logout-icon.svg"}
                width={"16px"}
                height={"16px"}
                alt="logout"
              />
            </MenuItem>
          </Menu>
        </>
      )}
    </>
  );
}

export default ProfileMenu;
